import React from 'react';
import classNames from 'classnames';
import './CallToAction.styl';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

interface CallToActionProps {
  text?: JSX.Element | string;
  dismissible?: boolean;
  orientation?: 'right' | 'left';
  onDismiss?: () => void;
}

export const CallToAction: React.FC<CallToActionProps> = ({
  text = undefined,
  dismissible = undefined,
  orientation = 'left',
  onDismiss = undefined,
}) => (
  <div className={'mascot-cta'}>
    <DialogBubble
      text={text}
      orientation={orientation}
      dismissible={dismissible}
      onDismiss={onDismiss}
    />
  </div>
);

export const DialogBubble = ({text, orientation, dismissible, onDismiss}) => (
  <div className="dialog-bubble-wrapper">
    <div className={classNames('bubble', orientation)}>
      {text}
      {dismissible && (
        <div className={'dismiss-icon'}>
          <CloseIcon color={'gray'} onClick={onDismiss} />
        </div>
      )}
    </div>
  </div>
);
